import { Link } from 'react-router-dom'
import { ThemeProvider } from '@/lib/theme'
import { toLocale, useI18n } from '@/lib/i18n'
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import { useDocumentMeta } from '@/lib/useDocumentMeta'
import { NOT_FOUND } from '@/lib/seo'
import '@/styles/imprint.css'

/**
 * Any path the site does not serve. Prerendered as dist/404.html, which
 * Firebase Hosting returns with a real 404 status (no soft-404 home page).
 */
export default function NotFoundPage() {
  const { lang, to } = useI18n()
  const locale = toLocale(lang)
  useDocumentMeta({ ...NOT_FOUND[locale], locale })
  return (
    <ThemeProvider>
      <Header active="home" onNavigate={() => {}} />

      <main className="imprint-page">
        <div className="container imprint-content">
          <span className="eyebrow">404</span>
          {locale === 'de' ? (
            <>
              <h1 className="imprint-title">Seite nicht gefunden</h1>
              <section className="imprint-section">
                <p>
                  Diese Seite gibt es nicht oder nicht mehr. SoftMaze Solutions GmbH ist ein
                  Software-Studio in Wien — sehen Sie sich unsere <Link to={to('/projects')}>Projekte</Link>{' '}
                  und <Link to={to('/services')}>Leistungen</Link> an oder{' '}
                  <Link to={to('/contact')}>nehmen Sie Kontakt auf</Link>.
                </p>
                <p>
                  <Link to={to('/')}>Zur Startseite</Link>
                </p>
              </section>
            </>
          ) : (
            <>
              <h1 className="imprint-title">Page not found</h1>
              <section className="imprint-section">
                <p>
                  This page does not exist or has moved. SoftMaze Solutions GmbH is a software studio
                  in Vienna — see our <Link to={to('/projects')}>projects</Link>, read about{' '}
                  <Link to={to('/services')}>our services</Link> or <Link to={to('/contact')}>get in touch</Link>.
                </p>
                <p>
                  <Link to={to('/')}>Back to the home page</Link>
                </p>
              </section>
            </>
          )}
        </div>
      </main>

      <Footer />
    </ThemeProvider>
  )
}
